import { observer } from "mobx-react-lite"
import { Button, Image, InputNumber, Space, Tag, Row, Col } from "antd";
import i from "../../../../translations/i"
import { storeSession } from "../../../../helpers/stores"
import { getPrice } from "../../../../helpers/price"
import { customToFixed } from "../../../../helpers/project.controller";


export const OrderProducts = observer(({ items, editable, setQuantity, deleteProduct }: any) => {


  return(
    <>
        <div className="order__products">
            {items && items.filter((item: any) => item.product).map((item: any, index: number) => {
                let className = 'item'
                if(editable) {
                    className += ' item-editable'
                }
                if(item.product.is_set) className += ' item-is_set'
                if(!item.product.image) className += ' item-no-image'

                type ModifierGroup = {
                    key: string;
                    name: string;
                    items: any[];
                };

                const modifierGroups = Object.values(
                    ((item.modifiers ?? []) as any[]).reduce<Record<string, ModifierGroup>>((acc, el) => {
                        const groupKey = String(el.group?.id ?? 'without_group');
                        const groupName = el.group?.name ?? '';

                        if (!acc[groupKey]) {
                            acc[groupKey] = {
                                key: groupKey,
                                name: groupName,
                                items: [],
                            };
                        }

                        acc[groupKey].items.push(el);

                        return acc;
                    }, {})
                );

                // Единица приходит вместе с товаром заказа; справочник project_units — запасной вариант
                const unitName: string = item.product.unit?.name
                    ?? storeSession.get("project_units")?.find((el: any) => el.id === item.product.unit_id)?.name
                    ?? '';

                return (
                  <>
                    <div className={className} key={index}>
                      {item.product && item.product.image &&
                        <div className="item__image">
                          <Image src={item.product.image.path} />
                        </div>
                      }

                      <div className="item__meta">
                        {item.product && item.product.seller &&
                          <div className="item__meta-vendor"><a href={`/settings/managers/${item.product.seller.manager_id}`} target="_blank">{i.t('def:seller')}: #{item.product.seller.manager_id} - {item.product.seller.manager.firstname ?? ''} {item.product.seller.manager.lastname ?? ''} ({item.product.seller.manager.email})</a></div>
                        }
                        {item.product && item.product.vendor_code &&
                          <div className="item__meta-vendor">{i.t('def:vendor')}: {item.product.vendor_code}</div>
                        }
                        {item.product && item.product.name &&
                          <div className="item__meta-name">{item.product.name}</div>
                        }
                        {item.price_type && (item.price_type.name || item.price_type.private_name) &&
                          <div className="item__meta-price-type">
                            <Tag>{i.t('def:Price type')}: {item.price_type.name ?? item.price_type.private_name}</Tag>
                          </div>
                        }
                        {(Array.isArray(item.props) && item.props.length > 0) &&
                          <div className="item__meta-props">
                            {item.props.map((el: any) => (<Tag>{el.category.name}: {el.value.value}</Tag>))}
                          </div>
                        }
                          {modifierGroups.length > 0 &&
                              <div className="item__meta-modifiers">
                                  {modifierGroups.map((group) => (
                                      <div className="item__meta-modifier-group" key={group.key}>
                                          {group.name &&
                                              <div className="item__meta-modifier-group-title">
                                                  {group.name}
                                              </div>
                                          }

                                          {group.items.map((el: any) => (
                                              <div className="item__meta-modifier" key={el.id}>
                                                    <span className="item__meta-modifier-count">
                                                      × {el.count ?? 0}
                                                    </span>

                                                    <span className="item__meta-modifier-name">
                                                      {el.modifier?.name ?? '—'}
                                                    </span>
                                              </div>
                                          ))}
                                      </div>
                                  ))}
                              </div>
                          }
                      </div>

                      <div className="item__quantity">
                        <div className="item__quantity-label">{i.t('def:count')}</div>
                        <div className="item__quantity-value">
                          {editable
                            ? <>
                              <InputNumber
                                style={{ width: '100%' }}
                                value={item.product && (item.product.weight_goods || item.product.step !== 1)
                                  ? customToFixed(item.count * item.product.step, 3)
                                  : item.count}
                                onChange={(e: any) => {
                                  setQuantity(item.id, e, item.product.weight_goods, item.product.step)
                                }}
                              />
                            </>
                            : <>
                              {item.product && item.product.unit_id && item.product.step ? customToFixed(item.count * item.product.step, 3) : item.count}
                            </>
                          }
                          &nbsp;
                          {unitName}
                        </div>
                      </div>

                      <div className="item__price">
                        {item.price_without_discount != null && item.price_without_discount !== item.price && item.price_without_discount > 0 &&
                            <div className="item__price-old">
                                {getPrice(customToFixed(item.price_without_discount * item.count, 3))}
                            </div>
                        }

                        {Array.isArray(item.discounts) && item.discounts.length > 0 &&
                            <div className="item__price-discounts">
                                {[...item.discounts]
                                    .sort((a: any, b: any) => (a.amount > 0 ? 1 : 0) - (b.amount > 0 ? 1 : 0))
                                    .map((discount: any) => (
                                        <span
                                            className={`item__price-discount ${discount.amount > 0 ? 'item__price-discount--positive' : 'item__price-discount--negative'}`}
                                            key={discount.id}
                                        >
                                            {discount.label ?? discount.type}: {discount.amount > 0 ? '+' : ''}{getPrice(discount.amount)}
                                        </span>
                                    ))}
                            </div>
                        }

                        <div className="item__price-final">
                            {item.price ? getPrice(customToFixed(item.price * item.count, 3)) : ''}
                        </div>
                      </div>

                      {editable &&
                        <div className="item__remove">
                          <Button
                            danger
                            type="dashed"
                            onClick={() => deleteProduct(item.id)}
                          >{i.t('def:actions.remove')}</Button>
                        </div>
                      }

                    </div>

                    {item.product.is_set
                      ? <div className="order__products product_is_set">
                        <OrderProducts
                          items={item.product.sets}
                          editable={false}
                          setQuantity={null}
                          deleteProduct={null}
                        />
                        {/*{item.product.sets.map((set_product: any) => (*/}
                        {/*  <div>*/}
                        {/*    {set_product.product.name}*/}
                        {/*  </div>*/}
                        {/*))}*/}
                      </div>
                      : <></>
                    }

                  </>
                )
            })}
        </div>
    </>
  )
})